import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ScanConsole from '../components/ScanConsole';
import { Reveal, TiltCard } from '../components/motion';
import { FREE_TOOLS } from './freeToolsData';
import './freeToolsCatalog.css';

const KIND_LABEL = { tool: 'Free tool', scan: 'Live scan', account: 'Free account' };

function toolHref(tool) {
  if (tool.kind === 'tool') return `/free-tools/${tool.slug}`;
  if (tool.kind === 'account') return '/dashboard';
  return '/free-tools#visibility-scan';
}

export default function FreeToolsPage() {
  return (
    <>
      <section className="page-hero is-tight">
        <Reveal className="page-hero-inner">
          <div className="section-tag">FREE TOOLS</div>
          <h1>Genuinely useful tools. No account, no catch.</h1>
          <p>Run a live visibility scan, generate schema, build tracking links, and audit your own local SEO — free, in your browser.</p>
        </Reveal>
        <Reveal className="page-hero-console" delay={100}>
          <ScanConsole />
        </Reveal>
      </section>

      <section className="free-catalog">
        <Reveal className="section-header">
          <div className="section-tag">THE TOOLBOX</div>
          <h2 className="section-title">Everything you can use right now.</h2>
          <p className="section-sub">Each tool solves one real problem local businesses search for every day.</p>
        </Reveal>
        <div className="free-catalog-grid">
          {FREE_TOOLS.map((tool, index) => {
            const Icon = tool.icon;
            const href = toolHref(tool);
            const internal = tool.kind !== 'scan';
            const Card = internal ? Link : 'a';
            return (
              <TiltCard as="article" className="free-tool-card" intensity={6} lift={6} key={tool.slug} style={{ '--i': index }}>
                <Card {...(internal ? { to: href } : { href })} className="free-tool-link">
                  <span className="free-tool-icon"><Icon size={19} /></span>
                  <span className="free-tool-kind">{KIND_LABEL[tool.kind]}</span>
                  <h3>{tool.name}</h3>
                  <p className="free-tool-tagline">{tool.tagline}</p>
                  <p className="free-tool-blurb">{tool.blurb}</p>
                  <span className="free-tool-cta">Open tool <ArrowRight size={14} /></span>
                </Card>
              </TiltCard>
            );
          })}
        </div>
      </section>

      <section className="home-cta">
        <div className="home-cta-inner">
          <div>
            <div className="section-tag">KEEP THE RESULTS</div>
            <h2>Save your scans and track them over time.</h2>
            <p>A free account stores every scan, tracks keyword positions, and keeps your leads in one pipeline.</p>
          </div>
          <div className="home-cta-actions">
            <Link to="/signup" className="btn-primary">Create your account <ArrowRight size={16} /></Link>
            <Link to="/pricing" className="btn-ghost">Compare plans</Link>
          </div>
        </div>
      </section>
    </>
  );
}
